import { cn } from '@/utils/cn';
import type { HTMLAttributes } from 'react';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-2xl border border-gray-100 bg-white p-6 shadow-soft', className)}
      {...props}
    />
  );
}

export function Alert({ className, variant = 'error', ...props }: HTMLAttributes<HTMLDivElement> & { variant?: 'error' | 'success' | 'info' }) {
  const styles = {
    error: 'border-red-200 bg-red-50 text-red-700',
    success: 'border-green-200 bg-green-50 text-green-700',
    info: 'border-blue-200 bg-blue-50 text-blue-700',
  };

  return (
    <div className={cn('rounded-xl border px-4 py-3 text-sm', styles[variant], className)} {...props} />
  );
}
